import { Link, Navigate, Route, Routes } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton, Typography } from '@mui/material';
import Component from '../../components/Component';
import DailyMissionAnalytics from './DailyMissionAnalytics';
import DailyMissionEditor from './DailyMissionEditor';
import DailyMissionList from './DailyMissionList';

function DailyMissions() {
  return (
    <Component>
      <div
        className="daily-missions-container"
        style={{
          marginLeft: '280px',
          marginTop: '80px',
          padding: '20px',
          width: 'calc(100% - 280px)',
        }}
      >
        <div className="d-flex align-items-center mb-2">
          <IconButton style={{ background: '#FFFFFF' }} component={Link} to="/">
            <ArrowBackIcon />
          </IconButton>
          <div style={{ marginLeft: '12px' }}>
            <h2 style={{ margin: 0 }}>Daily Missions</h2>
            <Typography variant="body2" color="text.secondary">
              One mission per date, made of tasks. Days with no mission show nothing in the app. Career
              missions stay on{' '}
              <Link to="/admin/missions">Missions</Link>.
            </Typography>
          </div>
        </div>

        <Routes>
          <Route index element={<DailyMissionList />} />
          <Route path="analytics" element={<DailyMissionAnalytics />} />
          <Route path="new" element={<DailyMissionEditor />} />
          <Route path=":id" element={<DailyMissionEditor />} />
          <Route path="*" element={<Navigate to="/admin/daily-missions" replace />} />
        </Routes>
      </div>
    </Component>
  );
}

export default DailyMissions;
